import { z } from 'zod';

// Zod probes `new Function('')` to decide whether it may JIT-compile object
// validators. It catches the throw and falls back to interpreted parsing, but a
// CSP without 'unsafe-eval' still reports the refusal once per page load.
// Opting out of the JIT skips the probe; under our CSP it was never usable.
//
// Import `z` from here rather than from 'zod' (enforced by no-restricted-imports):
// ESM evaluates this module before any importer, so no schema can be built
// before the config applies, whatever order imports end up in.
z.config({ jitless: true });

export { z };
